// src/api/chatApi.js
//
// Endpoints de mensajería directa entre veci y negocio.

import { api } from './apiClient';

export const chat = {
  /** Lista las conversaciones del usuario (rol veci o negocio). */
  conversaciones: () =>
    api.get('/api/holaveci/conversaciones'),

  /** Detalle + mensajes de una conversación. */
  detalle: (conversacionId, params = {}) =>
    api.get(`/api/holaveci/conversaciones/${conversacionId}`, { query: params }),

  /** Marca los mensajes como vistos (baja el badge). */
  marcarVisto: (conversacionId) =>
    api.post(`/api/holaveci/conversaciones/${conversacionId}/visto`, {}),

  /** Envía un mensaje. Si la conversación no existe, la crea con la contraparte. */
  enviar: (payload) =>
    api.post('/api/holaveci/mensajes', payload),

  /** Total no leídos (para el badge del menú). */
  noLeidos: () =>
    api.get('/api/holaveci/conversaciones/no-leidos'),
};
